"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var textbox_1 = require("@csod/textbox");
var EnhancedInput = textbox_1.compose({
    description: true,
    enterKey: true,
    icons: true,
    loading: true
})(textbox_1.Input);
var SearchTextbox = /** @class */ (function (_super) {
    __extends(SearchTextbox, _super);
    function SearchTextbox(props) {
        var _this = _super.call(this, props) || this;
        _this.isControlled = _this.props.value !== undefined;
        _this.onBlur = function (event) {
            var _a = _this.props, id = _a.id, onBlur = _a.onBlur;
            var value = event.target.value;
            /* istanbul ignore else */
            if (onBlur) {
                onBlur(value, id, event);
            }
        };
        _this.onChange = function (event) {
            var _a = _this.props, id = _a.id, onChange = _a.onChange;
            var value = event.target.value;
            /* istanbul ignore else */
            if (onChange) {
                onChange(value, id, event);
            }
            _this.syncValue(value);
        };
        _this.onEnter = function (event) {
            var _a = _this.props, id = _a.id, onEnter = _a.onEnter;
            var value = event.target.value;
            /* istanbul ignore else */
            if (onEnter) {
                onEnter(value, id, event);
            }
        };
        _this.onFocus = function (event) {
            var _a = _this.props, id = _a.id, onFocus = _a.onFocus;
            var value = event.target.value;
            /* istanbul ignore else */
            if (onFocus) {
                onFocus(value, id, event);
            }
        };
        _this.onRightIconClick = function () {
            var onRightIconClick = _this.props.onRightIconClick;
            if (onRightIconClick) {
                onRightIconClick();
            }
            else if (!_this.isControlled) {
                _this.input.value = '';
                _this.syncValue('');
            }
            _this.input.focus();
        };
        _this.syncValue = function (value) {
            _this.setState(function () { return ({ _value: value }); });
        };
        _this.ref = function (ref) {
            var inputRef = _this.props.inputRef;
            if (inputRef) {
                inputRef(ref);
            }
            _this.input = ref;
        };
        _this.rightIcon = {
            'aria-label': _this.props.rightIconAriaLabel || 'Clear',
            name: 'button',
            onClick: _this.onRightIconClick,
            onMouseDown: _this.props.onRightIconMouseDown,
            role: 'button',
            title: _this.props.rightIconTooltip || 'Clear'
        };
        _this.state = {
            /**
             * Internal use only. Actual value of input is dependent on consumer.
             */
            _value: _this.isControlled ? _this.props.value : _this.props.defaultValue
        };
        return _this;
    }
    SearchTextbox.prototype.componentWillReceiveProps = function (_a) {
        var value = _a.value;
        if (this.isControlled) {
            this.syncValue(value);
        }
    };
    SearchTextbox.prototype.render = function () {
        var _a = this.props, ariaLabel = _a.ariaLabel, ariaLabelledBy = _a.ariaLabelledBy, autoFocus = _a.autoFocus, defaultValue = _a.defaultValue, errorMessage = _a.errorMessage, hasError = _a.hasError, id = _a.id, isEnabled = _a.isEnabled, isLoading = _a.isLoading, onBlur = _a.onBlur, onEnter = _a.onEnter, onFocus = _a.onFocus, placeholder = _a.placeholder, tag = _a.tag, value = _a.value;
        var _value = this.state._value;
        return (React.createElement(EnhancedInput, { id: id, tag: tag, "aria-disabled": !isEnabled, "aria-invalid": hasError, "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy, autoFocus: autoFocus, defaultValue: defaultValue, disabled: !isEnabled, errorMessage: hasError && errorMessage, hasError: hasError, inputRef: this.ref, isLoading: isLoading, leftIcon: "magnifying-glass", onBlur: onBlur && this.onBlur, onChange: this.onChange, onEnter: onEnter && this.onEnter, onFocus: onFocus && this.onFocus, placeholder: placeholder, rightIcon: _value && this.rightIcon, type: "search", value: value }));
    };
    SearchTextbox.displayName = 'SearchTextbox';
    SearchTextbox.defaultProps = {
        isEnabled: true
    };
    return SearchTextbox;
}(React.PureComponent));
exports.SearchTextbox = SearchTextbox;
exports.default = SearchTextbox;
//# sourceMappingURL=SearchTextbox.js.map


//////////////////
// WEBPACK FOOTER
// ../@csod/search-textbox/build/control/SearchTextbox.js
// module id = 905
// module chunks = 0